<template>
    <div class="container-fluid">
        <Breadcrumb v-bind:title="'Edit Relay Reputation Provider #' + id" v-bind:button-show="false"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <ReputationProviderForm :id="id" @hidePreloader="hidePreloader"></ReputationProviderForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import ReputationProviderForm from './forms/ReputationProviderForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'ReputationProvider',
        props: ['id'],
        components: {
            Preloader, ReputationProviderForm, Breadcrumb
        },
        data() {
            return {
                loading: false
            }
        },
        mounted() {
                this.loading = true;
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>
